@if (storyCommentsLoaded) {
  <div class="box-comment">
    @if (canCreateStoryComment()) {
      <app-story-comment-form-teacher [storyUserId]="storyUserId" [grade]="grade" (saveNewStoryComment)="onsaveNewStoryComment($event)">
      </app-story-comment-form-teacher>
    }
    @for (storyComment of storyComments; track storyComment.id) {
      @switch (storyComment !== edittingStoryComment) {
        @case (true) {
          <app-story-comment-detail-teacher
            [storyComment]="storyComment"
            [canEdit]="canEditStoryComment(storyComment)"
            (editStoryComment)="onEditStoryComment(storyComment)"
          >
          </app-story-comment-detail-teacher>
        }
        @case (false) {
          <app-story-comment-form-teacher
            [storyUserId]="storyUserId"
            [grade]="grade"
            [storyComment]="storyComment"
            (cancelEditStoryComment)="onCancelEditStoryComment()"
            (updateOldStoryComment)="onUpdateOldStoryComment($event, storyComment)"
            (deleteOldStoryComment)="onDeleteOldStoryComment(storyComment)"
          >
          </app-story-comment-form-teacher>
        }
      }
    }
    @if (canLoadMore) {
      <div class="load-more">
        <a class="spen-util-link" (click)="loadMoreStoryComments()">
          <span>もっと見る</span>
          <i [class]="isLoadingMore ? 'fa fa-spinner fa-spin' : 'fa fa-chevron-down'"></i>
        </a>
      </div>
    }
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
